import _Clear from "@material-ui/icons/esm/Clear";
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import { INFO_MESSAGE } from 'swag-client-common/utils/constants';
import classes from './info-message.scss';
export class InfoMessage extends React.Component {
  constructor(props, context) {
    super(props, context);
    _defineProperty(this, "timeout", void 0);
    this.state = {
      isShown: false,
      wasLogoInteracted: {}
    };
    this.hideMessage = this.hideMessage.bind(this);
    this.getMessage = this.getMessage.bind(this);
    this.hideMessage = this.hideMessage.bind(this);
  }
  static getDerivedStateFromProps(props, state) {
    if (props.logos.length === 0) {
      return {
        wasLogoInteracted: _objectSpread({}, state.wasLogoInteracted, {
          [props.view]: false
        })
      };
    }
    if (props.isLogoDeleted) {
      return {
        isShown: false
      };
    }
    if (props.isSamplePromo || state.wasLogoInteracted[props.view] || props.logos.length !== 1) {
      return null;
    }
    if (!props.isLogoInteracted || state.wasLogoInteracted[props.view]) {
      return null;
    }
    return {
      isShown: true,
      wasLogoInteracted: _objectSpread({}, state.wasLogoInteracted, {
        [props.view]: true
      })
    };
  }
  componentDidUpdate(prevProps, prevState) {
    if (!prevState.isShown && this.state.isShown) {
      this.timeout = setTimeout(() => {
        this.setState({
          isShown: false
        });
      }, 10000);
    }
  }
  componentWillUnmount() {
    clearTimeout(this.timeout);
  }
  hideMessage() {
    this.setState({
      isShown: false
    });
  }
  getMessage(isEditingSharedItem) {
    const messageObject = isEditingSharedItem ? INFO_MESSAGE.SHARED_ITEM_EDIT : INFO_MESSAGE.DONT_WORRY;
    const {
      title,
      text
    } = messageObject;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
      className: classes.title
    }, title), /*#__PURE__*/React.createElement("p", {
      className: classes.message
    }, text));
  }
  render() {
    const {
      isShown
    } = this.state;
    const {
      className,
      isEditingSharedItem,
      isLimitedEdition
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.infoMessage, className, {
        [classes.showMessage]: isShown,
        [classes.orangeBackground]: isLimitedEdition
      })
    }, /*#__PURE__*/React.createElement(_Clear, {
      className: classnames(classes.closeIcon, {
        [classes.orangeBackground]: isLimitedEdition
      }),
      onClick: this.hideMessage
    }), this.getMessage(isEditingSharedItem));
  }
}